import React from 'react';
import { NavLink }from 'react-router-dom';
import GetAllRoutines from '../api/Routines';

const Directory = (props => {
  const { user, token, setUser, setRoutine } = props
    return (<>
    &nbsp;&nbsp;
    { user && token ? <span><b><i class="fas fa-seedling"></i>&nbsp;Welcome Back!</b></span> : ""}
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    <div>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    <ul class="nav nav-tabs">
    <li class="nav-item">
    <NavLink to="/routines" activeClassName="current" style={{ color : 'black'}}>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Home
    </NavLink>
    </li>
    &nbsp;&nbsp;&nbsp;
    <li>
    <NavLink to="/routines" activeClassName="current" style={{ color : 'black'}}>
      
      Routines
    </NavLink>
    </li>
    &nbsp;&nbsp;&nbsp;
    <li class ="nav-item">
    <NavLink to="/activities" activeClassName="current" style={{ color : 'black'}}>
      
      
      Activities
    </NavLink>
    </li>
    &nbsp;&nbsp;&nbsp;
    { user && token ? <li class ="nav-item">
    <NavLink to="/myroutines" activeClassName="current" style={{ color : 'black'}} onClick={() => {
      GetAllRoutines().then(setRoutine);
    }}>
      
      
      myRoutines
    </NavLink>
    </li> : ""}
    &nbsp;&nbsp;&nbsp;
    <li class="nav-item">
    <NavLink to="/login" activeClassName="current" style={{ color : 'black'}}>
    
      Login
    </NavLink>
    </li>
    &nbsp;&nbsp;&nbsp;
    <li class="nav-item">
    <NavLink to="/register" activeClassName="current" style={{ color : 'black'}}>
    
      Sign-Up
    </NavLink>
    </li>
    &nbsp;&nbsp;&nbsp;
  </ul>
    
  </div>
  
  
  
  </>);
})

export default Directory;